import type { MetaProps } from '@benzinga/seo';
import type { HeaderProps } from '../../../src/entities/header';

export type PageConfig =
  | {
      statusCode?: number;
      pageTargeting?: Record<string, string | string[]>;
      disablePushPrompt?: boolean;
      includeAGGridStyles?: boolean;
      disableFooterDisplayAd?: boolean;
      deferDisplayAdUntilReady?: boolean;
      /** @deprecated Use disableFooterDisplayAd */
      disableStickyFooter?: boolean;
      /** @deprecated Use disableFooterDisplayAd */
      disableRaptiveFooter?: boolean;
      /** @deprecated Use deferDisplayAdUntilReady */
      disableAdsReadyOnPageLoad?: boolean;
      /** @deprecated Use deferDisplayAdUntilReady */
      disableRaptiveReadyOnPageLoad?: boolean;
      queryParams?: Record<string, string | string[]>;
      headerProps?: HeaderProps;
      embeddedWidget?: boolean;
      error?: number;
      metaProps?: MetaProps;
    }
  | Record<string, any>;

export interface PageLayoutProps {
  pageProps?: PageConfig;
}

export const resolveDisableFooterDisplayAd = (config: PageConfig = {}): boolean =>
  !!(config.disableFooterDisplayAd ?? config.disableStickyFooter ?? config.disableRaptiveFooter);

export const resolveDeferDisplayAdUntilReady = (config: PageConfig = {}): boolean | undefined =>
  config.deferDisplayAdUntilReady ?? config.disableAdsReadyOnPageLoad ?? config.disableRaptiveReadyOnPageLoad;
